/*
|-------------------------------------------------------------------------------
| 资方信息
|-------------------------------------------------------------------------------
*/
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

const vendorStore = defineStore({
  state: () => ({
    /**
     * 产品线id
     */
    productId: '',
    /**
     * 供应商id
     */
    fundsChannelId: '',
  }),
  mutations: {
    /**
     * 设置供应商信息
     */
    saveVendor(state, data) {
      Object.assign(state, data)
    },
  },
})

export default vendorStore
export type IVendorStoreState = IStoreState<
  typeof vendorStore.state
>
